import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { fadeAnimation } from '@app/animations';
import * as FollowActions from '@core/actions/follow.actions';
import * as RuleActions from '@core/actions/rule.actions';
import * as FollowAreaActions from '@app/modules/follow/actions/follow.actions';
import * as SeasonActions from '@core/actions/season.actions';
import * as FollowGroupActions from '@core/actions/follow-group.actions';
import * as CountryActions from '@core/actions/country.actions';
import * as DepartmentActions from '@core/actions/department.actions';
import * as fromFollows from '@core/reducers/follow.reducer';
import * as fromSelectedFollow from '@app/modules/follow/reducers/follow.reducer';
import * as fromRoot from '@core/reducers/root.reducer';
import { select, Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-follow-layout',
  templateUrl: './follow-layout.component.html',
  styleUrls: ['./follow-layout.component.css'],
  animations: [fadeAnimation]
})
export class FollowLayoutComponent implements OnInit, OnDestroy {
  me$ = this.store.pipe(select(fromRoot.getMe));
  follow$ = this.store.pipe(select(fromSelectedFollow.getPopulated));
  followId$ = this.store.pipe(select(fromSelectedFollow.getId));

  _alive = true;

  constructor(private store: Store<any>, private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.params.pipe(takeWhile(() => this._alive)).subscribe(params => {
      const followId = parseInt(params.followId, 10);
      this.store.dispatch(new FollowAreaActions.Select(followId));
      this.store.dispatch(new FollowActions.LoadSingle(followId));
      // this.store.dispatch(new DepartmentActions.LoadCalculated(followId));
    });

    this.store.dispatch(new DepartmentActions.Load());
    this.store.dispatch(new SeasonActions.Load());
    this.store.dispatch(new RuleActions.Load());

    this.store.dispatch(new CountryActions.Load());
    this.store.dispatch(new FollowGroupActions.Load());

    this.follow$.pipe(takeWhile(() => this._alive)).subscribe(follow => {
      if (follow && follow.DepartmentId) {
        this.store.dispatch(new DepartmentActions.Select(follow.DepartmentId));
      }
      if (follow && follow.SeasonId) {
        this.store.dispatch(new SeasonActions.Select(follow.SeasonId));
      }
    });
  }

  ngOnDestroy() {
    this._alive = false;
    this.store.dispatch(new FollowAreaActions.Select(null));
  }

  public getRouterOutletState(outlet) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

  onActivate(e, element) {
    element.scrollTo(0, 0);
  }
}
